import memoize from 'memoize-one';
export const getVNextUsers = memoize((state) => {
    const userStore = state.get('vNextUserStore');
    const users = userStore.get('users');
    return users;
});
